import api from "../../utils/interface";

// Public endpoint: reads the PaymentData row the Cashfree webhook writes to.
// Callers must handle a 404 (no such order) separately from 5xx / network
// errors, which are transient and should be retried.
export const getPaymentStatus = (orderId) =>
  api
    .get("/payment/status", {
      params: { order_id: orderId },
      headers: { "Content-Type": "application/json" },
    })
    .then((res) => res?.data);
